import { getFirestore, doc, collection, getDocs, onSnapshot } from "firebase/firestore"
import getCollectionPath from '@/services/firestore/getCollectionPath'
import catalogueCommands from '@/commands/catalogueCommands'

const db = getFirestore()
const collectionName = 'buildings/'

function docToInstance(doc) {
  const data = doc.data()
  return data ? new Building(doc.id, data.name, data.image, data.description, data.type, data.buyingMode, data.price, data.amortization, data.lossOnSale, data.paimentDelay, data.taxes, data.charges, data.maintnanceCost, data.bonuses, data.staffAmount, data.storageAmount, data.available) : null
}

export default class Building {
  constructor(id, name, image, description,  type, buyingMode, price, amortization, lossOnSale, paimentDelay, taxes, charges, maintnanceCost, bonuses, staffAmount = 0, storageAmount = 0, available = true) {
    this.id = id
    this.name = name
    this.image = image
    this.description = description
    this.type = type
    this.buyingMode = buyingMode
    this.price = price
    this.amortization = amortization
    this.lossOnSale = lossOnSale
    this.paimentDelay = paimentDelay
    this.taxes = taxes
    this.charges = charges
    this.maintnanceCost = maintnanceCost
    this.bonuses = bonuses
    this.staffAmount = staffAmount
    this.storageAmount = storageAmount
    this.available = available
  }

  static initOne(){
    let building = new Building(null, 'Nouveau bâtiment', 'Building', '', 'Office', 'Buy', 150000, 60, 5, 30, 1500, 1500, 2500, [], 0, 0, true)
    return building
  }

  async save() {
    const data = {
      name: this.name,
      image: this.image,
      description: this.description,
      type: this.type,
      buyingMode: this.buyingMode,
      price: this.price,
      amortization: this.amortization,
      lossOnSale: this.lossOnSale,
      paimentDelay: this.paimentDelay,
      taxes: this.taxes,
      charges: this.charges,
      maintnanceCost: this.maintnanceCost,
      bonuses: this.bonuses,
      staffAmount: this.staffAmount,
      storageAmount: this.storageAmount,
      available: this.available
    }

    if (this.id) {
      await catalogueCommands.building.update(this.id, data)
    } else {
      const result = await catalogueCommands.building.create(data)
      this.id = result.id
    }
    return this
  }

  static async listenAll(callback) {
    onSnapshot(collection(db, await getCollectionPath(collectionName)), snapshot => {
      const list = []
      snapshot.forEach(doc => {
        list.push(docToInstance(doc))
      })
      callback(list)
    })
  }

  static async listenById(id, callback) {
    return onSnapshot(doc(db, await getCollectionPath(collectionName), id), snapshot => {
      callback(docToInstance(snapshot))
    })
  }

  static async getAll(){
    const documents = await getDocs(collection(db, await getCollectionPath(collectionName)))
    return documents.docs.map(docToInstance)
  }


  async delete() {
    await catalogueCommands.building.delete(this.id)
  }
}
